import { DirectiveBinding, ObjectDirective, VNodeDirective } from "vue";

interface HTMLElementWithClickOutside extends HTMLElement {
	__vueClickOutside__?: (e: MouseEvent) => void;
}

function registerClickOutside(
	el: HTMLElementWithClickOutside,
	binding: DirectiveBinding | VNodeDirective
) {
	const handler = (e: MouseEvent) => {
		if (!el.contains(e.target as Node)) {
			(binding.value as (e: MouseEvent) => void)(e);
		}
	};
	el.__vueClickOutside__ = handler;
	document.addEventListener("mousedown", handler);
}

function unregisterClickOutside(el: HTMLElementWithClickOutside) {
	if (el.__vueClickOutside__) {
		document.removeEventListener("mousedown", el.__vueClickOutside__);
		delete el.__vueClickOutside__;
	}
}

const clickOutside: ObjectDirective = {
	inserted(el: HTMLElementWithClickOutside, binding: VNodeDirective) {
		registerClickOutside(el, binding);
	},

	unbind(el: HTMLElementWithClickOutside) {
		unregisterClickOutside(el);
	}
};

const clickOutsideVue3: ObjectDirective = {
	mounted(el: HTMLElementWithClickOutside, binding: DirectiveBinding) {
		registerClickOutside(el, binding);
	},
	unmounted(el: HTMLElementWithClickOutside) {
		unregisterClickOutside(el);
	}
};

export default { ...clickOutside, ...clickOutsideVue3 };
